import {Onboarding} from '../auth/onboarding/Onboarding'
import React from 'react'
import { observer } from 'mobx-react-lite';

export const snapPoints = ['80%']

export const Component = observer(() => {
  return <Onboarding />;
});